import { gql } from "@apollo/client";

export const ASSIGN_STUDENT_MUTATION = gql(/* GraphQL */ `
  mutation AssignPersonStudents($personId: UUID!, $studentIds: [UUID!]!) {
    assignPersonStudents(
      input: { personId: $personId, studentIds: $studentIds }
    ) {
      __typename
      person {
        id
      }
      errors {
        ... on ValidationError {
          message
          errors {
            fieldName
            messages
          }
        }
      }
    }
  }
`);
